import { useState } from "react";
import { Badge, Col, Row } from "react-bootstrap";
import { CommonSelect } from "../../Input";
import DataTable from "../../table/DataTable";
import DetailFieldWrapper from "./DetailFieldWrapper";

// Import bill images
import bill100 from "../../../../images/cash/100_dollar.png";
import bill10 from "../../../../images/cash/10_dollar.png";
import bill1 from "../../../../images/cash/1_dollar.png";
import bill20 from "../../../../images/cash/20_dollar.png";
import bill50 from "../../../../images/cash/50_dollar.png";
import bill5 from "../../../../images/cash/5_dollar.png";
import coin1 from "../../../../images/cash/1_dollar_bronze.png";
import coin50c from "../../../../images/cash/50_cents.png";
import coin25c from "../../../../images/cash/25_cents.png";
import coin10c from "../../../../images/cash/10_cents.png";
import coin5c from "../../../../images/cash/5_cents.png";
import coin1c from "../../../../images/cash/1_cent.png";

const Step4TransactionDenomination = () => {
  const [inQuantities, setInQuantities] = useState({});
  const [outQuantities, setOutQuantities] = useState({});

  const denominations = [
    {
      id: "bill100",
      label: "100 Dollars",
      value: 100,
      type: "bill",
      image: bill100,
    },
    {
      id: "bill50",
      label: "50 Dollars",
      value: 50,
      type: "bill",
      image: bill50,
    },
    {
      id: "bill20",
      label: "20 Dollars",
      value: 20,
      type: "bill",
      image: bill20,
    },
    {
      id: "bill10",
      label: "10 Dollars",
      value: 10,
      type: "bill",
      image: bill10,
    },
    { id: "bill5", label: "5 Dollars", value: 5, type: "bill", image: bill5 },
    { id: "bill1", label: "1 Dollar", value: 1, type: "bill", image: bill1 },
    { id: "coin1", label: "1 Dollar", value: 1, type: "coin", image: coin1 },
    { id: "coin50c", label: "50 Cents", value: 0.5, type: "coin", image: coin50c },
    { id: "coin25c", label: "25 Cents", value: 0.25, type: "coin", image: coin25c },
    { id: "coin10c", label: "10 Cents", value: 0.1, type: "coin", image: coin10c },
    { id: "coin5c", label: "5 Cents", value: 0.05, type: "coin", image: coin5c },
    { id: "coin1c", label: "1 Cent", value: 0.01, type: "coin", image: coin1c },
  ];

  const handleInChange = (id, val) =>
    setInQuantities({ ...inQuantities, [id]: parseInt(val) || 0 });
  const handleOutChange = (id, val) =>
    setOutQuantities({ ...outQuantities, [id]: parseInt(val) || 0 });

  const getColumns = (type, quantities, onChange) => [
    {
      label: "IMAGE",
      key: "image",
      className: "ps-4",
      render: (item) => (
        <div
          className="d-flex align-items-center justify-content-center border rounded overflow-hidden bg-white"
          style={{ width: "45px", height: "30px", borderColor: "#eee" }}
        >
          {item.image ? (
            <img
              src={item.image}
              alt={item.label}
              style={{ width: "100%", height: "auto" }}
            />
          ) : (
            <div
              className="rounded-circle d-flex align-items-center justify-content-center fw-bold"
              style={{
                width: "20px",
                height: "20px",
                fontSize: "8px",
                backgroundColor: item.id.includes("coin1")
                  ? "#FFC107"
                  : "#E2E8F0",
                color: item.id.includes("coin1") ? "#fff" : "#64748B",
                border: "1px solid rgba(0,0,0,0.05)",
              }}
            >
              $
            </div>
          )}
        </div>
      ),
    },
    {
      label: "DENOMINATION",
      key: "label",
      render: (item) => (
        <span className="fs-12 fw-medium text-black">{item.label}</span>
      ),
    },
    ...(type === "out"
      ? [
          {
            label: "INVENTORY",
            key: "inventory",
            render: () => <span className="text-muted fs-11">--</span>,
          },
        ]
      : []),
    {
      label: "QUANTITY",
      key: "quantity",
      render: (item) => (
        <input
          type="number"
          className="form-control text-center"
          style={{
            height: "32px",
            width: "80px",
            fontSize: "12px",
            backgroundColor: "#fff",
            border: "1px solid #E2E8F0",
            borderRadius: "6px",
          }}
          value={quantities[item.id] || ""}
          placeholder="0"
          onChange={(e) => onChange(item.id, e.target.value)}
        />
      ),
      className: "px-2",
    },
    {
      label: "TOTAL",
      key: "total",
      className: "pe-4",
      render: (item) => (
        <div className="text-end fw-bold fs-12 text-black">
          USD {(item.value * (quantities[item.id] || 0)).toFixed(2)}
        </div>
      ),
    },
  ];

  return (
    <div className="mt-4 pb-2">
      {/* Search Header Design */}
      <div className="bg-white rounded-4 shadow-sm p-4 mb-4 border border-light">
        <Row className="g-4">
          <Col md={4}>
            <DetailFieldWrapper label="Payment Method">
              <CommonSelect
                placeholder="Cash"
                options={[{ value: "cash", label: "Cash" }]}
              />
            </DetailFieldWrapper>
          </Col>
          <Col md={4}>
            <DetailFieldWrapper label="Total Paid">
              <div
                className="d-flex align-items-center bg-light border rounded-3 px-3"
                style={{ height: "45px" }}
              >
                <span className="text-muted fs-12 me-2">USD</span>
                <span className="fw-bold text-black fs-14">1.019</span>
              </div>
            </DetailFieldWrapper>
          </Col>
          <Col md={4}>
            <DetailFieldWrapper label="Change Amount">
              <div
                className="d-flex align-items-center bg-light border rounded-3 px-3"
                style={{ height: "45px" }}
              >
                <span className="text-muted fs-12 me-2">USD</span>
                <span className="fw-bold text-black fs-14">0.00</span>
              </div>
            </DetailFieldWrapper>
          </Col>
        </Row>
      </div>

      <Row className="g-4">
        {/* Left Column: Cash In */}
        <Col lg={6}>
          <div
            className="bg-white rounded-4 shadow-sm p-3 mb-3 border border-light d-flex flex-column justify-content-center"
            style={{ height: "85px" }}
          >
            <div
              className="text-muted fs-11 fw-bold text-uppercase mb-1"
              style={{ letterSpacing: "0.05em" }}
            >
              Actual Cash Receive
            </div>
            <div className="fw-bold fs-18 text-primary">USD 0</div>
          </div>
          <div className="card border-0 shadow-sm rounded-4 overflow-hidden border border-light">
            <DataTable
              columns={getColumns("in", inQuantities, handleInChange)}
              data={denominations}
              showPagination={false}
              minWidth="100%"
            />
          </div>
        </Col>

        {/* Right Column: Calculations and Change Out */}
        <Col lg={6}>
          <div
            className="bg-white rounded-4 shadow-sm p-3 mb-3 border border-light d-flex align-items-center"
            style={{ height: "85px" }}
          >
            <Row className="g-2 w-100 px-0 mx-0">
              {[
                { label: "Cash Transfer Amount:", value: "1.019 USD" },
                { label: "Actual Cash Receive:", value: "0 USD" },
                {
                  label: "Expected Change:",
                  value: "0 USD",
                  extra: (
                    <Badge
                      bg="success"
                      className="ms-2 rounded-pill bg-opacity-10 text-success fw-bold"
                      style={{ fontSize: "9px", padding: "4px 8px" }}
                    >
                      Rounded
                    </Badge>
                  ),
                },
                { label: "Actual Change:", value: "USD 0" },
              ].map((item, id) => (
                <Col md={6} key={id}>
                  <div
                    className="d-flex justify-content-between align-items-center border rounded-3 p-1 px-2 bg-light bg-opacity-10 h-100"
                    style={{ minHeight: "32px" }}
                  >
                    <span className="text-muted" style={{ fontSize: "10px" }}>
                      {item.label}
                    </span>
                    <div className="d-flex align-items-center">
                      <span
                        className="fw-bold text-black"
                        style={{ fontSize: "12px" }}
                      >
                        {item.value}
                      </span>
                      {item.extra}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
          <div className="card border-0 shadow-sm rounded-4 overflow-hidden border border-light">
            <DataTable
              columns={getColumns("out", outQuantities, handleOutChange)}
              data={denominations}
              showPagination={false}
              minWidth="100%"
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Step4TransactionDenomination;
